// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__151vA","productName":"Table_productName__3_A7u"};